export const TALENT_FILTERS_SET_SEARCH_MODE = '@@talentFilters/SET_SEARCH_MODE';
export const TALENT_FILTERS_SET_SEARCH_ID = '@@talentFilters/SET_SEARCH_ID';
export const TALENT_FILTERS_SET_SEARCH_FIRST_NAME =
  '@@talentFilters/SET_SEARCH_FIRST_NAME';
export const TALENT_FILTERS_SET_SEARCH_LAST_NAME =
  '@@talentFilters/SET_SEARCH_LAST_NAME';
export const TALENT_FILTERS_SET_SEARCH_EMAIL =
  '@@talentFilters/SET_SEARCH_EMAIL';
export const TALENT_FILTERS_RESET_SEARCH = '@@talentFilters/RESET_SEARCH';

export const TALENT_FILTERS_SET_TALENTS_MODE =
  '@@talentFilters/SET_TALENTS_MODE';
